import aiMl from '../../images/cms_images/ai-ml.webp'
import cmsBlockchain from '../../images/cms_images/blockchain.webp'

export const swiftAssets = {
  swift: {
    emerging: {
      emerging1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/emerging/arkit.webp`,
      emerging2: cmsBlockchain,
      emerging3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/emerging/cloud-computing.webp`,
      emerging4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/emerging/iot.webp`,
      emerging5: aiMl,
      emerging6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/emerging/vr.webp`,
    },
    process: {
      process1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/process/discovery.webp`,
      process2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/process/ux-design.webp`,
      process3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/process/app-development.webp`,
      process4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/process/testing.webp`,
      process5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/process/deployment.webp`,
      process6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/process/support-and-maintenance.webp`,
    },
    services: {
      service1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/swift services/swift-app-consultation.svg`,
      service2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/swift services/swift-app-prototyping.svg`,
      service3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/swift services/swift-app-ui-ux-design.svg`,
      service4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/swift services/swift-app-development.svg`,
      service5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/swift services/swift-app-testing.svg`,
      service6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/swift services/swift-app-maintenance-support.svg`,
    },
    whyApp: {
      reason1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/why swift/blazing-fast-speed.svg`,
      reason2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/why swift/security.svg`,
      reason3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/why swift/effective-memory-management.svg`,
      reason4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/why swift/interoperable-with-objective-c.svg`,
      reason5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/why swift/low-maintenance.svg`,
      reason6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/why swift/type-safe-language.svg`,
    },
    whyKonstant: {
      reason1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/Why choose konstant/competencies-in-swift-framework.svg`,
      reason2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/Why choose konstant/experienced-qa.svg`,
      reason3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/Why choose konstant/expertise-in-multiple-os.svg`,
      reason4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/Why choose konstant/customer-driven-strategy.svg`,
      reason5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/Why choose konstant/timely-delivery.svg`,
      reason6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift page/Why choose konstant/customer-centric-designs.svg`,
    },
    bg: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/swift_bg.svg`,
  },
};
